import MinusCircleOutlined from '@ant-design/icons/MinusCircleOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import Button from 'antd/es/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Space from 'antd/es/space';
import React from 'react';

interface DynamicArrayProps {
  label: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  help?: string;
  minItems?: number;
  maxItems?: number;
}

export const DynamicArray: React.FC<DynamicArrayProps> = ({
  label,
  name,
  placeholder,
  required = false,
  help,
  minItems = 0,
  maxItems,
}) => {
  return (
    <Form.Item label={label} help={help}>
      <Form.List
        name={name}
        rules={[
          {
            validator: async (_, values) => {
              if (required && (!values || values.length < minItems)) {
                throw new Error(
                  `At least ${minItems} ${label.toLowerCase()} required`,
                );
              }
            },
          },
        ]}
      >
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map(({ key, name: fieldName, ...restField }) => (
              <Space
                key={key}
                style={{ display: 'flex', marginBottom: 8 }}
                align="baseline"
              >
                <Form.Item
                  {...restField}
                  name={fieldName}
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}
                  style={{ flex: 1, marginBottom: 0 }}
                >
                  <Input
                    placeholder={placeholder}
                    style={{ fontFamily: 'monospace' }}
                  />
                </Form.Item>
                {fields.length > minItems && (
                  <MinusCircleOutlined
                    onClick={() => remove(fieldName)}
                    style={{ color: '#ff4d4f' }}
                  />
                )}
              </Space>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
                disabled={maxItems ? fields.length >= maxItems : false}
              >
                Add {label.toLowerCase()}
              </Button>
              <Form.ErrorList errors={errors} />
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
};
